module.exports = __webpack_public_path__ + "img/ewm.58b22494.jpg";